import { useNavigate } from "react-router-dom";
import uiStyles from "../theme/uiStyles";

export default function TermsAndConditions() {
  const nav = useNavigate();

  return (
    <div style={uiStyles.page}>
      <div style={{ ...uiStyles.card, ...styles.card }}>
        <button
          type="button"
          onClick={() => nav("/home")}
          style={styles.homeBtn}
        >
          Home
        </button>

        <div style={styles.headerRow}>
          <h1 style={styles.title}>Terms and Conditions for NextBite</h1>
        </div>
        <p style={styles.updated}>
          <strong>Last updated:</strong> April 23, 2026
        </p>

        <section style={styles.section}>
          <h2 style={styles.heading}>1. Acceptance of Terms</h2>
          <p>
            By using NextBite, you agree to these Terms and Conditions. If you
            do not agree, please do not use the app.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>2. Purpose of the App</h2>
          <p>
            NextBite provides food suggestions for children based on user input.
            The app is intended for informational and supportive purposes only.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>3. Not Medical Advice</h2>
          <p>
            NextBite does not provide medical or nutritional advice. Always
            consult a qualified professional for concerns about your child’s
            health, diet, or allergies.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>4. User Responsibility</h2>
          <p>You are responsible for:</p>
          <ul style={styles.list}>
            <li>Ensuring foods are safe for your child</li>
            <li>Considering allergies and dietary restrictions</li>
            <li>Supervising your child during meals</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>5. Data and Privacy</h2>
          <p>
            Your use of the app is also governed by our Privacy Policy. We aim
            to collect minimal data and do not sell personal information.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>6. App Availability</h2>
          <p>
            We may update, modify, or discontinue features at any time without
            notice.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>7. Limitation of Liability</h2>
          <p>NextBite is not responsible for:</p>
          <ul style={styles.list}>
            <li>Food reactions or allergies</li>
            <li>Feeding outcomes or preferences</li>
            <li>Any decisions made based on app suggestions</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>8. Changes to Terms</h2>
          <p>
            We may update these Terms. Continued use of the app means you accept
            the updated Terms.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>9. Contact</h2>
          <p>If you have questions, please use our feedback form.</p>
          <button
            type="button"
            onClick={() => nav("/feedback")}
            style={styles.feedbackLink}
          >
            Open Feedback Form
          </button>
        </section>
      </div>
    </div>
  );
}

const styles = {
  card: {
    position: "relative"
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    paddingRight: 110
  },
  title: {
    marginTop: 0,
    marginBottom: 12
  },
  updated: {
    marginTop: 0,
    color: "#475569"
  },
  section: {
    marginTop: 24
  },
  heading: {
    marginBottom: 8
  },
  list: {
    paddingLeft: 20,
    lineHeight: 1.7
  },
  feedbackLink: {
    border: "none",
    background: "transparent",
    padding: 0,
    color: "#2563eb",
    cursor: "pointer",
    fontSize: 15,
    textDecoration: "underline"
  },
  homeBtn: {
    position: "absolute",
    top: 18,
    right: 18,
    padding: "10px 16px",
    borderRadius: 999,
    border: "1px solid #f0d9d1",
    background: "rgba(255,255,255,0.85)",
    color: "#7c3d2e",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600
  }
};
